function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#45DB5D",
  fillOpacity: 0.15
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5103 11.2641C20.725 11.2641 22.5203 10.5306 22.5203 9.62585C22.5203 8.72108 20.725 7.98761 18.5103 7.98761C16.2956 7.98761 14.5002 8.72108 14.5002 9.62585C14.5002 10.5306 16.2956 11.2641 18.5103 11.2641Z",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5203 12.2847C22.5203 12.8372 21.8808 13.3248 20.8447 13.5849C20.0842 13.7961 19.2985 13.8989 18.5102 13.8904C17.7241 13.8985 16.9406 13.7957 16.1823 13.5849C15.1654 13.2923 14.5066 12.8047 14.5066 12.2847",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8045 16.6079C19.4854 16.5914 20.1619 16.491 20.8191 16.3088C21.836 16.0098 22.5012 15.5222 22.5012 14.9761",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8045 19.2472C19.4881 19.232 20.1671 19.1293 20.8255 18.9417C21.8424 18.6491 22.5012 18.1681 22.5012 17.6415",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5002 14.261V9.61932",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5203 9.62585V20.2744C22.5203 21.1391 20.8959 21.8412 18.8237 21.8997",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4897 18.6881C15.7044 18.6881 17.4998 17.9546 17.4998 17.0499C17.4998 16.1451 15.7044 15.4116 13.4897 15.4116C11.275 15.4116 9.47968 16.1451 9.47968 17.0499C9.47968 17.9546 11.275 18.6881 13.4897 18.6881Z",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5253 19.7153C17.5253 20.2614 16.8858 20.749 15.8497 21.048C15.0886 21.2561 14.3034 21.3589 13.5153 21.3536C12.7292 21.3593 11.9461 21.2566 11.1873 21.048C10.1704 20.749 9.50525 20.2614 9.50525 19.7153",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5253 17.0499V22.3741C17.5253 22.9267 16.8858 23.4078 15.8433 23.7069C15.085 23.9182 14.3015 24.021 13.5153 24.0124C12.7291 24.021 11.9456 23.9182 11.1873 23.7069C10.1704 23.4078 9.50525 22.9267 9.50525 22.3741V17.0499",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var SvgBranchTotalSmall = function SvgBranchTotalSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBranchTotalSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/branch-total-small.a91b2d0a.svg";
export { ForwardRef as ReactComponent };